import {
  DESIGN_UNIT_LIST,
  SELECTED_UNIT_ID,
  SELECT_TOOL,
  POP_LIST,
  UNIT_INFO,
  CHECK_ADDONS,
  DRAWER_RESULT,
  ADDONS_INFO,
  SAVE_ALL_OLGU_DATA_DESIGN,
  SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN,
  OLGU_DATA_SEARCH_DESIGN,
  NEW_UNIT_INFO,
  TOGGLE_UNIT_DRAWER,
  SELECT_UNITS,
  SELECTED_UNIT_COUNT,
  DESIGN_UNIT_LIST_LAZY,
  DESIGN_UNIT_LIST_RESET,
  SELECTEDPROFILETYPE,
  GET_BACK_FROM_DESIGN,
  DESIGN_RESCALE,
  DESIGN_OPENONEUNIT,
  DRAWER_RESET,
  ACTIVE_SILENT_DRAWER,
  DEACTIVE_SILENT_DRAWER,
  SHOW_UNIT_SIDE_DRAWER,
  DESIGNER_BREAK_FRAME,
  DESIGNER_BREAK_FRAME_ACTION,
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const INIT_STATE = {
  unitList: [],
  selectedUnitId: null,
  selectedUnitINfo: null,
  selectedUnitImage: null,
  selectedTool: {},
  popList: null,
  unitInfo: null,
  drawerResult: null,
  silentDrawer: { list: [], active: false },
  checkAddon: null,
  allOlguDataDesign: [],
  allOlguDataPaginationDesign: { Limit: 5, Page: 1, Total: 0 },
  dasteProfileListWithTypeDesign: [],
  selectedProfileType: 1,
  allOlguDataSearchDesign: null,
  newUnitInfo: null,
  isOpenUnitDrawer: false,
  unitListPagination: { Limit: 20, Page: 1, Total: 0 },
  selectUnits: [],
  selectedUnitCount: 0,
  getBack: 0, // 0: nothing, 1: get back and do save, 2: save ok for get back
  reScale: false,
  breakFrame: null,
  breakFrameAction: null,
  openUnit: 0,
  showUnitSideDrawer: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECTED_UNIT_COUNT:
      return updateObject(state, {
        selectedUnitCount: action.selectedUnitCount,
      });
    case SELECT_UNITS:
      return updateObject(state, {
        selectUnits: action.selectUnits,
      });
    case GET_BACK_FROM_DESIGN:
      return updateObject(state, {
        getBack: { mode: action.mode, URL: action.address },
      });
    case DESIGNER_BREAK_FRAME:
      return updateObject(state, {
        breakFrame: action.data,
      });
    case DESIGNER_BREAK_FRAME_ACTION:
      return updateObject(state, {
        breakFrameAction: action.data,
      });
    case SELECTEDPROFILETYPE:
      return updateObject(state, {
        selectedProfileType: action.selectedProfileType,
      });
    case DESIGN_RESCALE:
      return updateObject(state, {
        reScale: action.tun,
      });
    case DESIGN_OPENONEUNIT:
      return updateObject(state, {
        openUnit: action.id,
      });
    case NEW_UNIT_INFO:
      return updateObject(state, {
        newUnitInfo: action.newUnitInfo,
      });
    case TOGGLE_UNIT_DRAWER:
      return updateObject(state, {
        isOpenUnitDrawer: action.isOpenUnitDrawer,
      });
    case OLGU_DATA_SEARCH_DESIGN:
      return updateObject(state, {
        allOlguDataSearchDesign: action.allOlguDataSearchDesign,
      });
    case SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN:
      return updateObject(state, {
        dasteProfileListWithTypeDesign: action.dasteProfileListWithTypeDesign,
      });
    case SAVE_ALL_OLGU_DATA_DESIGN:
      return updateObject(state, {
        allOlguDataDesign: action.allOlguDataDesign,
        allOlguDataPaginationDesign: action.allOlguDataPaginationDesign,
      });
    case ADDONS_INFO:
      return updateObject(state, {
        addonsInfo: { ...state.addonsInfo, ...action.addonsInfo },
      });
    case CHECK_ADDONS:
      return updateObject(state, { checkAddon: action.checkAddon });
    case DRAWER_RESULT:
      return updateObject(state, {
        drawerResult: { ...state.drawerResult, ...action.drawerResult },
      });
    case DRAWER_RESET:
      return updateObject(state, {
        drawerResult: null,
        selectedUnitId: null,
        selectedUnitINfo: null,
        selectedUnitImage: null,
        openUnit: -1,
      });
    case UNIT_INFO:
      return updateObject(state, { unitInfo: action.unitInfo });
    case POP_LIST:
      return updateObject(state, { popList: action.popList });
    case SELECT_TOOL:
      return updateObject(state, { selectedTool: action.selectedTool });
    case SELECTED_UNIT_ID:
      return updateObject(state, {
        selectedUnitId: action.selectedUnitId
          ? action.selectedUnitId
          : state.selectedUnitId,
        selectedUnitINfo: action.selectedUnitINfo
          ? action.selectedUnitINfo
          : state.selectedUnitINfo,
        selectedUnitImage: action.selectedUnitImage
          ? action.selectedUnitImage
          : state.selectedUnitImage,
      });
    case DESIGN_UNIT_LIST:
      return updateObject(state, {
        unitList: action.unitList,
        unitListPagination: action.unitListPagination,
      });
    case DESIGN_UNIT_LIST_LAZY:
      return updateObject(state, {
        unitList: action.lastList.concat(action.unitList),
        unitListPagination: action.unitListPagination,
      });
    case DESIGN_UNIT_LIST_RESET:
      return updateObject(state, {
        unitList: [],
        selectedUnitId: null,
        selectedUnitINfo: null,
        selectedUnitImage: null,
        unitListPagination: { Limit: 20, Page: 1, Total: 0 },
      });
    case ACTIVE_SILENT_DRAWER:
      return updateObject(state, {
        silentDrawer: {
          list: action.list,
          active: action.active,
        },
      });
    case DEACTIVE_SILENT_DRAWER:
      return updateObject(state, {
        silentDrawer: {
          list: [],
          active: false,
        },
      });
    case SHOW_UNIT_SIDE_DRAWER:
      return updateObject(state, {
        showUnitSideDrawer: action.status,
      });
    default:
      return state;
  }
};
